import type {StyleFunctionProps} from '@chakra-ui/styled-system';
import {mode} from '@chakra-ui/theme-tools';

import {core as dark} from '../design-tokens/dark';
import {core} from '../design-tokens/light';

export const intents = [`brand.success`, `brand.warning`, `danger`, `brand.info`] as const;
export type Intent = (typeof intents)[number];
export const isIntent = (value?: string): value is Intent => intents.includes(value as Intent);

const brandScheme = core.colors.brand;
const brandSchemeDark = dark.colors.brand;

export const getScheme = (props: {intent: Intent; props: StyleFunctionProps}) => {
  const schemes = {
    // green
    [`brand.success`]: {
      color: mode(brandScheme.success[`700`], brandSchemeDark.success[`100`])(props),
      background: mode(brandScheme.success[`100`], brandSchemeDark.success[`700`])(props),
    },
    // orange
    [`brand.warning`]: {
      color: mode(brandScheme.warning[`700`], brandSchemeDark.warning[`100`])(props),
      background: mode(brandScheme.warning[`100`], brandSchemeDark.warning[`700`])(props),
    },
    // red
    [`danger`]: {
      color: mode(brandScheme.danger[`700`], brandSchemeDark.danger[`100`])(props),
      background: mode(brandScheme.danger[`100`], brandSchemeDark.danger[`700`])(props),
    },
    // blue
    [`brand.info`]: {
      color: mode(core.colors.white[`100`], core.colors.black[`100`])(props),
      background: mode(core.colors.black[`100`], core.colors.white[`100`])(props),
    },
  };

  return schemes[props.intent];
};
